<template>

    <input type="number" ref="inputNumber" v-model="numericValue" @input="processInput" />

</template>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    props: {
        modelValue: { type: [String, Number, null], required: false, default: "" },
        maxlength: { type: Number, required: false, default: 100 },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            numericValue: null as string | null,
        };
    },
    mounted() {
        this.numericValue = this.modelValue?.toString();
    },
    methods: {
        isValid(): boolean {
            return (this.$refs.inputNumber as HTMLInputElement).validity.valid;
        },
        processInput(): void {
            this.$emit("update:modelValue", this.numericValue);
        },
    },
    watch: {
        modelValue(val: string | number | null) {
            this.numericValue = val?.toString() ?? "";
        },
    },
});

</script>
